import { Link } from "react-router-dom";
import { Mail, Phone, Clock, KeyRound, ArrowRight } from "lucide-react";

const H = { fontFamily: "Quicksand, sans-serif" };
export const TEAM_PHOTO = "/api/static/site/team-v3.webp";

export const PROCESS = [
  { icon: Mail, t: "Vous nous écrivez", d: "Par le formulaire de devis ou par email, 7j/7 de 10h à 20h." },
  { icon: Phone, t: "On vous rappelle", d: "Un membre de l'équipe vous appelle pour comprendre votre bien, vos besoins et les services souhaités." },
  { icon: KeyRound, t: "On vous oriente", d: "Nous vous mettons en relation avec la conciergerie qui correspond vraiment à votre projet." },
];

export function ContactHours({ dark }) {
  return (
    <div className={`rounded-2xl p-5 flex items-start gap-3 ${dark ? "bg-white/10 text-white" : "bg-secondary"}`} data-testid="contact-hours">
      <Clock size={20} className={dark ? "text-[hsl(var(--ocean))] shrink-0" : "text-[hsl(var(--ocean))] shrink-0"} />
      <div className="text-sm">
        <div className="font-bold" style={H}>Joignables 7j/7, de 10h à 20h</div>
        <div className={dark ? "text-white/75 mt-0.5" : "text-muted-foreground mt-0.5"}>
          Par email à <a href="mailto:contact@bretagneconciergerie.fr" className="underline font-semibold">contact@bretagneconciergerie.fr</a>, puis nous vous rappelons par téléphone.
        </div>
      </div>
    </div>
  );
}

export default function AboutTeam() {
  return (
    <section className="py-20 md:py-28" data-testid="about-team">
      <div className="container-tm grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 relative">
          <div className="absolute -left-8 -bottom-8 w-48 h-48 rounded-full bg-secondary -z-10 hidden lg:block" />
          <img src={TEAM_PHOTO} alt="L'équipe Bretagne Conciergerie Comparateur" className="w-full aspect-[3/2] object-cover blob" loading="lazy" data-testid="team-photo" />
        </div>
        <div className="lg:col-span-6">
          <span className="pill">Qui sommes-nous</span>
          <h2 className="h-section mt-4 text-accent">Créé par des propriétaires qui en avaient assez de chercher</h2>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            Nous aussi, nous louons nos biens en Bretagne. Nous avons passé des semaines à appeler des conciergeries, à comparer des devis
            impossibles à comparer, à découvrir trop tard qu&apos;une agence ne couvrait pas notre commune.
          </p>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Alors nous avons créé le service que nous aurions aimé trouver : <strong className="text-foreground">une seule demande, une vraie personne qui vous rappelle,
            et la bonne conciergerie pour votre bien</strong>. Gratuit pour les propriétaires.
          </p>
          <div className="mt-8 grid sm:grid-cols-3 gap-4">
            {PROCESS.map((p, i) => (
              <div key={p.t} data-testid={`about-step-${i}`}>
                <span className="w-10 h-10 rounded-full bg-[hsl(var(--ocean))] text-white flex items-center justify-center"><p.icon size={17} /></span>
                <div className="font-bold mt-3" style={H}>{p.t}</div>
                <div className="text-sm text-muted-foreground mt-1 leading-relaxed">{p.d}</div>
              </div>
            ))}
          </div>
          <div className="mt-8"><ContactHours /></div>
          <Link to="/qui-sommes-nous" className="btn-ghost mt-6" data-testid="about-more-link">Découvrir notre histoire <ArrowRight size={16} /></Link>
        </div>
      </div>
    </section>
  );
}

export function CityTeamBlock({ city }) {
  return (
    <section className="py-16 section-beige mx-3 md:mx-6" data-testid="city-team-block">
      <div className="container-tm grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <img src={TEAM_PHOTO} alt={`L'équipe Bretagne Conciergerie Comparateur, conciergerie à ${city}`} className="w-full aspect-[3/2] object-cover blob" loading="lazy" data-testid="city-team-photo" />
        </div>
        <div className="lg:col-span-7">
          <span className="pill bg-white">Qui sommes-nous</span>
          <h2 className="h-section mt-4 text-accent">Des propriétaires qui vous aident à trouver votre conciergerie à {city}</h2>
          <p className="mt-4 text-muted-foreground leading-relaxed">
            Nous aussi, nous louons nos biens en Bretagne, et nous avons perdu des semaines à chercher une conciergerie fiable.
            Nous avons créé le service que nous aurions aimé trouver : <strong className="text-foreground">une seule demande, une vraie personne qui vous rappelle,
            et la bonne conciergerie pour votre bien à {city}</strong>.
          </p>
          <div className="mt-6 grid sm:grid-cols-3 gap-4">
            {PROCESS.map((p, i) => (
              <div key={p.t} className="flex sm:block gap-3" data-testid={`city-team-step-${i}`}>
                <span className="w-9 h-9 rounded-full bg-[hsl(var(--ocean))] text-white flex items-center justify-center shrink-0"><p.icon size={16} /></span>
                <div>
                  <div className="font-bold mt-0 sm:mt-3" style={H}>{p.t}</div>
                  <div className="text-sm text-muted-foreground mt-1 leading-relaxed">{p.d}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-6 bg-white rounded-2xl"><ContactHours /></div>
        </div>
      </div>
    </section>
  );
}
